import { getToken } from './getToken';
import './spinner';

/**
 * Paginate class.
 *
 *  showResultsBlk{String} - class wrapper of block
 *  paginationBtn{String} - class of btn pagination btn
 *  paginationBtnNext{String} - class of btn pagination next
 *  paginationBtnPrev{String} - class of btn pagination prev
 */
export class Paginate{

    constructor(data){
        this.showResultsBlk = data.showResultsBlk;
        this.paginationBtn = data.paginationBtn;
        this.paginationBtnNext = data.paginationBtnNext;
        this.paginationBtnPrev = data.paginationBtnPrev;

        this.url = '';

        this.state = {
            id: '',
            page: '',
            items: '',
            _token : ''
        };
    }

    init(){

        this.state._token = getToken();

        /**
         * Pagination
         */
        if(this.paginationBtn) {
            this.initPaginationBtnClick(this.paginationBtn);
        }
        if(this.paginationBtnPrev) {
            this.initPaginationBtnPrevClick(this.paginationBtnPrev);
        }
        if(this.paginationBtnNext) {
            this.initPaginationBtnNextClick(this.paginationBtnNext);
        }

    }

    /**
     * Init function on click pagination btn next
     */
    initPaginationBtnNextClick(btn){
        let _this = this;
        $('body').on('click', btn,function(e){
            e.preventDefault();
            let curPage = $(_this.paginationBtn).parent('li').filter('.__active');
            curPage.removeClass('__active');
            curPage.next().addClass('__active');
            _this.state.page = Number(curPage.text()) +1;
            _this.submitPagination($(this));
        });
    }

    /**
     * Init function on click pagination btn prev
     */
    initPaginationBtnPrevClick(btn){
        let _this = this;
        $('body').on('click', btn,function(e){
            e.preventDefault();
            let curPage = $(_this.paginationBtn).parent('li').filter('.__active');
            curPage.removeClass('__active');
            curPage.prev().addClass('__active');
            _this.state.page = Number(curPage.text()) -1;
            _this.submitPagination($(this));
        });
    }

    /**
     * Init function on click pagination btn
     */
    initPaginationBtnClick(btn){
        let _this = this;
        $('body').on('click', btn,function(e){
            e.preventDefault();
            $(btn).parent('li').removeClass('__active');
            $(this).parent('li').addClass('__active');
            _this.state.page = $(this).data('page');
            /*let page = _this.state.page;*/
            _this.submitPagination($(this));
        });
    }

    /**
     * Submit function on click pagination
     */
    submitPagination(thisBtn){
        let _this = this;
        _this.thisWrap = $(thisBtn).closest(_this.showResultsBlk);
        _this.amountPages = $(thisBtn).closest('ul').find('li').length-2;
        _this.url = $(thisBtn).data('action');
        _this.state.id = $(thisBtn).data('id');
        _this.state.items = $(thisBtn).data('items');

        _this.state.category = $(_this.thisWrap).attr('data-category');
        _this.state.category_id = $(_this.thisWrap).attr('data-category-id');

        console.log(_this.state)

        $('body').spinnerAdd('js_pagination-spinner');
        _this.request(_this.successPaginationData);
    }

    /**
     * Append node items to wrap on click button pagination
     *
     * @param data
     */
    appendItemsPagination(data){
        this.thisWrap.html(data);
        $('#js_pagination-spinner').remove();
    }

    /**
     * On success request Pagination
     *
     * @param data
     */
    successPaginationData(data){
        let _this = this;
        this.appendItemsPagination(data);
        if(_this.state.page == _this.amountPages){
            $(this.paginationBtnNext).addClass('disabled');
        }else{
            $(this.paginationBtnNext).removeClass('disabled');
        }
        if(_this.state.page <= 1){
            $(this.paginationBtnPrev).addClass('disabled');
        }else{
            $(this.paginationBtnPrev).removeClass('disabled');
        }
    }


    /**
     * Request to server with state.
     *
     * @param url{String} - request url
     * @param method{String} - POST
     * @param successCallback - callback function
     */
    request(successCallback, url = this.url, method = 'GET'){
        $.ajax({
            method: method,
            url: url,
            data: this.state,
            success: data => {
                if(typeof(successCallback) === 'function') {
                    successCallback.call(this, data);
                    return;
                }
            },
            error: function (error) {
                console.log('Error');
            }
        });
    }

}
